module.exports = __webpack_public_path__ + "img/4d7bd6ea8e58620dd63dd9ff4220c4af.svg";